import { PaginationParams } from "types/general.interface";
import { IEvent, IEventCreate } from "types/event.interface";
import { handleGetRequest, handlePostRequest } from "./http.service";
import { PaginationDataRes } from "types/http.type";

export const getEvents = async (query: PaginationParams) => {
  const queryString = constructQuery(query);
  return await handleGetRequest<PaginationDataRes<IEvent[]>>(
    `/admins/events${queryString}`
  );
};

export const createEvent = async (payload: IEventCreate) => {
  return await handlePostRequest<IEventCreate, IEvent>(
    `/admins/events`,
    payload
  );
};

const constructQuery = (query: PaginationParams) => {
  let queryString = `?page=${query.page}&limit=${query.limit}`;

  return queryString;
};
